import React, { useState } from "react";
import { Button } from "djinn-components";
import ContentImageUpload from "../../ContentImageUpload";

interface ACPImageEditModalType {
  initialValue?: string;
  onSave: (v: string) => void;
  onComplete: () => void;
}

const ACPImageEditModal: React.FC<ACPImageEditModalType> = ({
  initialValue,
  onSave,
  onComplete
}) => {
  const [value, setValue] = useState(initialValue ?? "");

  const save = async () => {
    onSave(value);
    onComplete();
  };

  return (
    <div className="p">
      <div>
        <div className="mt-2 text-center sm:mt-5">
          <div className="mt-6 relative">
            <ContentImageUpload
              value={value}
              onChange={(e: string, fullPath: string) => {
                setValue(fullPath);
              }}
            />
          </div>
        </div>
      </div>
      <div className="mt-8 flex items-center">
        <span className="w-4/10 block mr-4">
          <Button
            text="Cancel"
            buttonStyle="red"
            type="button"
            onClick={onComplete}
          />
        </span>
        <Button
          text={"Save Changes"}
          buttonStyle="green"
          type="button"
          onClick={save}
        />
      </div>
      <div className="mt-10"></div>
    </div>
  );
};

export default ACPImageEditModal;
